var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTick(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#tick_svg__clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.456 17.329l-4.23-4.274a.779.779 0 010-1.096l.726-.732a.766.766 0 011.087-.001L10 14.198l6.961-6.972c.3-.302.787-.301 1.087 0l.727.733c.3.302.3.793 0 1.095l-8.23 8.275a.766.766 0 01-1.09 0z",
    fill: "#000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "tick_svg__clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M5 4h14v16H5z"
  })))));
}

export default SvgTick;